// LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlassMartiniAlt, faEye } from '@fortawesome/free-solid-svg-icons';
import { faGoogle, faApple } from '@fortawesome/free-brands-svg-icons';

function LoginPage({ setUserData }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Handle manual email/password login
  const handleEmailSubmit = (e) => {
    e.preventDefault();
    fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.message === 'Invalid credentials') {
          setError('Incorrect email or password');
        } else {
          console.log('Login response:', data);
          setUserData({
            userid: data.user.userid,
            access_token: data.user.access_token,
            refresh_token: data.user.refresh_token,
          });
          navigate('/home');
        }
      })
      .catch(err => {
        console.error('Login error:', err);
        setError('An error occurred. Please try again.');
      });
  };

  // Handle Google login success
  const handleGoogleSuccess = (response) => {
    console.log('Google Sign-In Success:', response);
    fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ googleToken: response.credential }),
    })
      .then(res => res.json())
      .then(data => {
        console.log('Backend Login response:', data);
        setUserData({
          userid: data.user.userid,
          access_token: data.user.access_token,
          refresh_token: data.user.refresh_token,
        });
        navigate('/home');
      })
      .catch(err => {
        console.error('Google Login error:', err);
        setError('Google login failed. Please try again.');
      });
  };

  // Handle Google login failure
  const handleGoogleError = (error) => {
    console.log('Google Login Failed:', error);
    setError('Google login prompt failed to display. Please try again or use manual login.');
  };

  return (
    <div className="login-container">
      <div className="gradient-bg"></div>
      <div className="content-container">
        {/* Logo and Title */}
        <div className="logo-section">
          <div className="logo-icon">
            <FontAwesomeIcon icon={faGlassMartiniAlt} />
          </div>
          <h1 className="app-title">Good-Call</h1>
          <p className="subtitle">Mix with confidence</p>
        </div>

        {/* Login Form */}
        <div className="login-form">
          <h2 className="form-title">Welcome Back</h2>
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleEmailSubmit}>
            <div className="input-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                placeholder="example@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field"
                required
              />
            </div>
            <div className="input-group">
              <div className="password-label">
                <label htmlFor="password">Password</label>
                <a href="#" className="forgot-password">Forgot password?</a>
              </div>
              <div className="password-input">
                <input
                  type="password"
                  id="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input-field"
                  required
                />
                <button type="button" className="eye-button">
                  <FontAwesomeIcon icon={faEye} />
                </button>
              </div>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="remember" className="checkbox" />
              <label htmlFor="remember">Remember me for 30 days</label>
            </div>
            <button type="submit" className="sign-in-button">Sign In</button>
          </form>

          <div className="divider">
            <span>or continue with</span>
          </div>

          <div className="social-buttons">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              use_fedcm_for_prompt={true}
              useOneTap={false}
              promptMomentNotification={(notification) => {
                if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                  console.log('Prompt not displayed or skipped:', notification.getNotDisplayedReason() || notification.getSkippedReason());
                  setError('Google login prompt failed to display. Please try again or use manual login.');
                }
              }}
              render={(renderProps) => (
                <button
                  type="button"
                  className="social-btn google-btn"
                  onClick={renderProps.onClick}
                  disabled={renderProps.disabled}
                >
                  <FontAwesomeIcon icon={faGoogle} className="mr-2" />
                  Google
                </button>
              )}
            />
            <button type="button" className="social-btn apple-btn">
              <FontAwesomeIcon icon={faApple} className="mr-2" />
              Apple
            </button>
          </div>

          <div className="signup-link">
            <p className="mb-3">
              Don't have an account? <a href="#" className="signup">Sign up</a>
            </p>
          </div>
        </div>

        {/* Terms */}
        <div className="terms">
          <p>
            By continuing, you agree to our{' '}
            <a href="#" className="terms-link">Terms of Service</a> and{' '}
            <a href="#" className="terms-link">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;